import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Austin.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Evolving the Digital Landscape With Premium Software Development
              in Austin
            </h2>
            <p>
              Austin's unique combination of technology and culture demands a
              fresh approach to software solutions. We don't just adapt to this
              dynamic environment; we lead the way. Our software development
              strategies and solutions are crafted to empower businesses to
              thrive in the digital age.
            </p>
            <p>
              As we navigate the digital landscape in Austin, we embrace
              emerging technologies, market trends, and the diverse needs of
              local businesses. Our aim is clear – to drive efficiency, enhance
              customer engagement, and foster growth through our tailored
              software solutions.
            </p>
            <p>
              By evolving the digital landscape, we're not just creating
              opportunities for our clients; we're contributing to Austin's
              evolution as a tech hub.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
